import { render } from "./Search.vue?vue&type=template&id=8a12c83e&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=8a12c83e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a12c83e"],['__file',"shared/src/entidades/builder/crud/infrastructure/search/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a12c83e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a12c83e', __exports__)) {
    api.reload('8a12c83e', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=8a12c83e&scoped=true&ts=true", () => {
    api.rerender('8a12c83e', render)
  })

}


export default __exports__